import type { BoardDto, MarkRequest, UpdateAssignmentRequest } from '@mm/shared';
import { apiFetch } from './client';

export async function patchAssignment(
  id: string,
  payload: UpdateAssignmentRequest,
): Promise<BoardDto> {
  const res = await apiFetch(`/boards/${id}/assignment`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`patchAssignment ${res.status}`);
  return res.json();
}

export async function markBoard(id: string, mark: MarkRequest['mark']): Promise<void> {
  const res = await apiFetch(`/boards/${id}/mark`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ mark }),
  });
  if (!res.ok) throw new Error(`markBoard ${res.status}`);
}

export async function tickTime(id: string, delta: number): Promise<void> {
  const res = await apiFetch(`/boards/${id}/time`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ delta }),
  });
  if (!res.ok) throw new Error(`tickTime ${res.status}`);
}
